import {
  Calendar,
  LayoutDashboard,
  Receipt,
  Settings,
  User,
} from "lucide-react";

/** @type {Record<string, import("react").ComponentType<{ className?: string }>>} */
export const MOBILE_TABBAR_ICON_MAP = {
  LayoutDashboard,
  Receipt,
  Calendar,
  User,
  Settings,
};
